import { useLazyQuery } from "@apollo/client";
import { GET_PROJECT_AND_TASKS } from "../../graphql/queries/ProjectContext";

// eslint-disable-next-line import/prefer-default-export
export const useGetProjectAndTasks = () => {
  const [getProjectAndTasks, { data, error, loading }] = useLazyQuery(GET_PROJECT_AND_TASKS);

  return [getProjectAndTasks, { data, error, loading }];
};
